export default __webpack_public_path__ + "static/V-ISO2_Korkea_ISO_alivalotettu-7b5319258993480275a5ee60fa97ac9b.jpg";